// Public Firebase web config (safe to commit; security = Authorized Domains + backend token verification).
export const firebaseConfig = {
  "apiKey": "AIzaSyDTCLP-BmTuZBCQLlyC_eGriDvlbkjz-yU",
  "authDomain": "atnd-cb.firebaseapp.com",
  "projectId": "atnd-cb",
  "appId": "1:307114448480:web:5106a6696e80068d51d505",
  "messagingSenderId": "307114448480",
  "storageBucket": "atnd-cb.firebasestorage.app"
};
